// UI time only: never advances the exercise, moves the camera or keeps WebGL awake.
export function createSpeechReveal({now=()=>performance.now(),delay=setTimeout,cancel=clearTimeout,onChange=()=>{}}={}){
 const cache=new Map();let message=null,elapsed=0,paused=true,last=now(),timer=null;
 function snapshot(){
  if(!message)return {key:null,text:'',fullText:'',complete:true,hidden:false,modal:false};
  const n=message.letters.length,duration=message.instant?0:Math.min(4200,n*26),count=duration?Math.min(n,Math.floor(elapsed/duration*n)):n;
  return {key:message.key,text:message.letters.slice(0,count).join(''),fullText:message.text,complete:count===n,hidden:false,modal:message.modal};
 }
 function stop(){if(timer!==null){cancel(timer);timer=null;}}
 function advance(){const at=now();if(message&&!paused)elapsed+=Math.max(0,at-last);last=at;}
 function notify(before){const after=snapshot();if(!before||before.key!==after.key||before.text!==after.text||before.hidden!==after.hidden||before.complete!==after.complete)onChange();}
 function schedule(){
  stop();if(paused||!message||snapshot().complete)return;
  timer=delay(()=>{timer=null;const before=snapshot();advance();notify(before);schedule();},24);
 }
 function remember(){if(!message)return;cache.set(message.key,{...message,elapsed});if(cache.size>64)cache.delete(cache.keys().next().value);}
 return {
  set({key,text='',modal=false,instant=false,paused:pause=false}){
   const before=snapshot();advance();text=String(text);
   if(!message||message.key!==key||message.text!==text||message.modal!==modal){
    remember();const saved=cache.get(key);message={key,text,modal,instant,letters:Array.from(text)};elapsed=saved?.text===text&&saved.modal===modal?saved.elapsed:0;
   }else message.instant=instant;
   paused=Boolean(pause);last=now();notify(before);schedule();
  },
  pause(value=true){const before=snapshot();advance();paused=Boolean(value);last=now();notify(before);schedule();},
  finish(){advance();const before=snapshot();if(!message||before.complete)return false;elapsed=Math.min(4200,message.letters.length*26);notify(before);schedule();return true;},
  read:snapshot,
  reset(){stop();cache.clear();message=null;elapsed=0;paused=true;last=now();onChange();},
  dispose(){stop();paused=true;}
 };
}
